import { render, staticRenderFns } from "./CopyFromTractDialog.vue?vue&type=template&id=efb0d582&"
import script from "./CopyFromTractDialog.vue?vue&type=script&lang=js&"
export * from "./CopyFromTractDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports